import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap, filter } from 'rxjs/operators';

import { AccountInvoice } from '../../model/account-invoice';
import { AccountInvoicesService } from '../../services/account-invoices.service';
import * as accountInformationActions from '../actions';
import { AccountType } from 'app/account/account-types.enum';
import { Account } from '../../model/account';

@Injectable()
export class AccountInvoicesEffect {
  @Effect()
  public loadAccountInvoices$ = this.actions$.pipe(
    ofType<accountInformationActions.LoadAccountInvoices>(
      accountInformationActions.LOAD_ACCOUNT_INVOICES
    ),
    switchMap(() =>
      this.accountInvoiceService.getAccountInvoices().pipe(
        map(
          (invoices: Array<AccountInvoice>) =>
            new accountInformationActions.LoadAccountInvoicesSuccess(invoices)
        ),
        catchError((error: any) =>
          of(new accountInformationActions.LoadAccountInvoicesFail(error))
        )
      )
    )
  );

  @Effect()
  public loadAccountInformationSuccess$ = this.actions$.pipe(
    ofType(accountInformationActions.LOAD_ACCOUNT_INFORMATION_SUCCESS),
    map(
      ({
        payload: account
      }: accountInformationActions.LoadAccountInformationSuccess) => account
    ),
    filter(
      (account: Account) =>
        account.type === AccountType.BLOCKED ||
        account.type === AccountType.SUSPENDED
    ),
    map(() => new accountInformationActions.LoadAccountInvoices())
  );

  constructor(
    private actions$: Actions,
    private accountInvoiceService: AccountInvoicesService
  ) {}
}
